import { Link, useNavigate } from 'react-router-dom';
import {blogArray} from './projectArray';
import { HiArrowLongRight } from "react-icons/hi2";
import './Blog.css';

const Blogs = () => {
    const navigate = useNavigate()
    return (
        <div>
            <section className="main-project-hero blog-hero">
                    <div className="project-name">
                        <h2>BLOG POSTS</h2>
                    </div>
            </section>
            
            <div className="grenchi-blogs">
                <h4 className='heading text-green'>Blog Posts</h4>
                <div className="blogs-container">
                    {blogArray.map((blogArray) => (
                        <div key={blogArray.id} className="blog-post" onClick={() => navigate(blogArray.url)} >
                            <div className="blog-post-img">
                                <img src={blogArray.image} alt={blogArray.title} />
                            </div>

                            <div className="blog-post-info">
                                <h5>{blogArray.title}</h5>
                                <p>{blogArray.Date ? <><span className="bold">Date:</span> {blogArray.Date}</> : null }</p>
                                <p>
                                    {blogArray.snippet?.slice(0, 115) + '... '}
                                    <Link to={blogArray.url} className='continue-reading'>Continue reading <HiArrowLongRight /></Link>
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Blogs;